module.exports = __webpack_public_path__ + "img/Mumbai_TCM Workshop.3697b374.jpg";